function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\t\t\t<div class=\"base-dialog-backdrop\n\t\t\t\t", " \n\t\t\t\t", "-backdrop\n\t\t\t\"></div>\n\t\t\t<div class=\"base-dialog ", " ", "\">\n\t\t\t\t<button type=\"button\" class=\"base-dialog__close\" @click=", ">\n\t\t\t\t\tClose\n\t\t\t\t</button>\n\t\t\t\t<div class=\"base-dialog__container\">\n\t\t\t\t\t<div class=\"base-dialog__content\">\n\t\t\t\t\t\t", "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { BaseDialog as CoreBaseDialog } from '@ovee.js/toolkit/index.cjs';
import gsap from 'gsap';

var _default = /*#__PURE__*/function (_CoreBaseDialog) {
  _inherits(_default, _CoreBaseDialog);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "immediate", false);

    return _this;
  }

  _createClass(_default, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.onPopState = this.onPopState.bind(this);
                _context.next = 3;
                return _get(_getPrototypeOf(_default.prototype), "init", this).call(this);

              case 3:
                _context.next = 5;
                return this.$requestUpdate();

              case 5:
                window.addEventListener('popstate', this.onPopState);
                this.immediate = true;
                this.checkHash();
                this.immediate = false;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "onPopState",
    value: function onPopState() {
      this.checkHash();
    }
  }, {
    key: "checkHash",
    value: function checkHash() {
      if (!this.id || document.location.hash.split('/')[0] !== "#".concat(this.id)) {
        return;
      }

      this.open();
    }
  }, {
    key: "prepareAdditionalHashData",
    value: function prepareAdditionalHashData() {
      return '';
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$emit('dialog:before-open', null);
                this.isOpen = true;
                document.documentElement.classList.add('dialog-open');
                _context2.next = 5;
                return new Promise(function (resolve) {
                  gsap.timeline({
                    onStart: function onStart() {
                      _this2.$emit('dialog:open-started', null);

                      if (_this2.id) {
                        window.history.replaceState(window.history.state, '', "".concat(document.location.href.split('#')[0], "#").concat(_this2.id).concat(_this2.prepareAdditionalHashData()));
                      }

                      _this2.immediate = false;
                    },
                    onComplete: resolve,
                    onInterrupt: resolve
                  }).fromTo(_this2.baseDialogBackdropElement, {
                    display: 'block',
                    autoAlpha: 0
                  }, {
                    autoAlpha: 1,
                    duration: _this2.immediate ? 0 : 0.4,
                    ease: 'power1.inOut'
                  }, 0).fromTo(_this2.baseDialogElement, {
                    autoAlpha: 0,
                    display: 'flex'
                  }, {
                    autoAlpha: 1,
                    duration: _this2.immediate ? 0 : 0.4,
                    ease: 'power1.inOut'
                  }, 0);
                });

              case 5:
                this.$emit('dialog:open', null);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.$emit('dialog:before-close', null);
                document.documentElement.classList.remove('dialog-open');
                _context3.next = 4;
                return new Promise(function (resolve) {
                  gsap.timeline({
                    onStart: function onStart() {
                      _this3.$emit('dialog:close-started', null);

                      if (_this3.id) {
                        window.history.replaceState(window.history.state, '', document.location.href.split('#')[0]);
                      }
                    },
                    onComplete: resolve,
                    onInterrupt: resolve
                  }).to(_this3.baseDialogBackdropElement, {
                    autoAlpha: 0,
                    duration: 0.4,
                    ease: 'power1.inOut',
                    onComplete: function onComplete() {
                      gsap.set(_this3.baseDialogBackdropElement, {
                        display: 'none'
                      });
                    }
                  }, 0).to(_this3.baseDialogElement, {
                    autoAlpha: 0,
                    duration: 0.4,
                    ease: 'power1.inOut',
                    onComplete: function onComplete() {
                      gsap.set(_this3.baseDialogElement, {
                        display: 'none'
                      });
                    }
                  }, 0);
                });

              case 4:
                this.isOpen = false;
                this.$emit('dialog:close', null);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "dialogWrapper",
    value: function dialogWrapper(content) {
      return this.html(_templateObject(), this.isOpen ? 'base-dialog-backdrop--is-open' : '', this.rootClass, this.isOpen ? 'base-dialog--is-open' : '', this.rootClass, this.close.bind(this), content);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(_default.prototype), "destroy", this).call(this);

      window.removeEventListener('popstate', this.onPopState);
    }
  }, {
    key: "baseDialogElement",
    get: function get() {
      return this.dialogTarget.querySelector('.base-dialog');
    }
  }, {
    key: "baseDialogBackdropElement",
    get: function get() {
      return this.dialogTarget.querySelector('.base-dialog-backdrop');
    }
  }, {
    key: "id",
    get: function get() {
      return this.$element.id;
    }
  }]);

  return _default;
}(CoreBaseDialog);

export { _default as default };